export const BlogsList: any = {
  MoviesAndShows: "Movies and Shows",
  PlacesAndActivites: "Places and Activities",
  CelebrationIdeas : "Celebration Ideas"
};
